import { ImgHTMLAttributes } from 'react';
import cardImage from './card-img.png';

export const DefaultCardImage = (props: ImgHTMLAttributes<HTMLImageElement>) => <img src={cardImage} alt="" />;
